export * from "./CustomShippingOptionWidgetVariantEmbeddedIterationTwo";
